import { h, Component } from 'preact';
import classNames from 'classnames';
import { connect } from 'preact-redux';
import { categoriesSelector } from 'app/desktop/selectors/categories';
import * as navbarActions from 'app/desktop/actions/navbar';

export class CategoriesFlyoutItem extends Component {
  constructor(props) {
    super(props);

    this.renderColumn = this.renderColumn.bind(this);
    this.renderLink = this.renderLink.bind(this);
    this.renderl2Columns = this.renderl2Columns.bind(this);
    this.renderCards = this.renderCards.bind(this);
    this.renderHeading = this.renderHeading.bind(this);
  }

  renderLink(link, i) {
    const { id, name, url } = link;

    if (id === 'all-deals') {
      return null;
    }

    return (
      <a
        className={classNames(`subcategories-link`, {
          clearance: id === 'goods-clearance',
        })}
        href={url}
        data-bhc={id ? `category:${id}` : undefined}
        role="menuitem"
        tabIndex="-1"
        key={id ? `category:${id}` : `category:${i}`}
      >
        {name}
      </a>
    );
  }

  renderColumn(links) {
    if (!links) {
      return null;
    }

    return links.map((column, index) => (
      <div
        className="categories-subcolumn subnav-categories"
        key={`column-${index}`}
      >
        {column.map(this.renderLink)}
      </div>
    ));
  }

  renderCards(cards, links) {
    if (!cards || links.length >= 3) {
      return null;
    }

    return cards.map((card, index) => (
      <div
        className="categories-subcolumn subnav-categories cards-column"
        key={`column-${card.group}-${index}`}
      >
        <a href={card.url} className="redesign-cards">
          <img
            className="cat-fly-select-img"
            alt={card.url}
            src={card.imgUrl}
          />
        </a>
      </div>
    ));
  }

  renderl2Columns() {
    const { flyoutCards, catFlyouts, activeCategory } = this.props;
    const flyout = (catFlyouts || []).find(fly => fly.id === activeCategory);
    if (!(flyoutCards && flyout)) {
      return null;
    }

    const { links, id } = flyout;
    const cards = flyoutCards[id]
      ? flyoutCards[id].cards.slice(0, 3 - links.length)
      : null;

    return (
      <div className="l2-columns">
        {this.renderColumn(links)}
        {this.renderCards(cards, links)}
      </div>
    );
  }

  renderHeading() {
    const { catFlyouts, activeCategory, t } = this.props;
    const flyout = catFlyouts.find(fly => fly.id === activeCategory);
    if (!flyout) {
      return null;
    }
    return (
      <h3 className="categories-l2-heading" key={flyout.id}>
        {flyout.label}
        <a className="shop-all-link" href={flyout.url}>
          {t.header.shopAll}
        </a>
      </h3>
    );
  }

  render() {
    return (
      <div className="categories-l2">
        {this.renderHeading()}
        {this.renderl2Columns()}
      </div>
    );
  }
}

export default connect(
  categoriesSelector,
  navbarActions
)(CategoriesFlyoutItem);
